import React, { useEffect, useState } from 'react'

import { get, post } from '../../config/fetch'

import Container from '@material-ui/core/Container'
import Grid from '@material-ui/core/Grid'
import Paper from '@material-ui/core/Paper'
import { makeStyles } from '@material-ui/core/styles'
import clsx from 'clsx'
import { Phone } from '@material-ui/icons'

import Total from './total'
import RadialBar from './radialbar'
import BarHorizontal from './barhorizontal'
import ProgressBar from './progressbar'
import { green } from '@material-ui/core/colors'
import CircularProgress from '@material-ui/core/CircularProgress'

const drawerWidth = 240

const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
        background: 'black'
    },
    toolbar: {
        paddingRight: 24, // keep right padding when drawer closed
    },
    toolbarIcon: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: '0 8px',
        ...theme.mixins.toolbar,
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    appBarShift: {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    menuButton: {
        marginRight: 36,
    },
    menuButtonHidden: {
        display: 'none',
    },
    title: {
        flexGrow: 1,
    },
    drawerPaper: {
        position: 'relative',
        whiteSpace: 'nowrap',
        width: drawerWidth,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    drawerPaperClose: {
        overflowX: 'hidden',
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        width: theme.spacing(7),
        [theme.breakpoints.up('sm')]: {
            width: theme.spacing(9),
        },
    },
    appBarSpacer: theme.mixins.toolbar,
    content: {
        flexGrow: 1,
        height: '100vh',
        overflow: 'auto',
    },
    container: {
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4),
    },
    paper: {
        padding: theme.spacing(2),
        magin: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
        backgroundColor: '#06171E',
    },
    paper2: {
        padding: theme.spacing(2),
        textAlign: 'center',
        color: theme.palette.text.secondary,
    },
    fixedHeight: {
        height: 705,
    },
    fixedHeight2: {
        height: 135,
    },
    fixedHeight3: {
        height: 345,
    },
}))

export default function Dashboard() {
    const classes = useStyles()
    const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight)
    const fixedHeightPaper2 = clsx(classes.paper, classes.fixedHeight2)
    const fixedHeightPaper3 = clsx(classes.paper, classes.fixedHeight3)

    const [dashboardData, setDashboardData] = useState()

    const [isLoading, setLoading] = useState(false)

    const fetchDashboardData = async data => {
        try {
            setLoading(true)
            const response = await get(
                `/dashboard?code=a8HtFW9CXbqZ7hWHzxwAweApJNckcRId6sKr3OahLL9K0rYafYZSaA==`,
            )
            setDashboardData(response.data)
            setLoading(false)
        } catch (e) {
            throw new Error(e)
        }
    }

    useEffect(() => {
        fetchDashboardData()
    }, [])

  
    return (
        <div className={classes.root}>
        
            <Container maxWidth="lg" className={classes.container}> 
                { isLoading ?
                <Grid container justify = "center">
                    <CircularProgress />
                </Grid> :
                <>
                <Grid container spacing={3}>
                    <Grid item xs={12} sm={6} md={3}>
                        <Paper className={fixedHeightPaper2}>
                            <Total
                                titulo={'Messages'}
                                indicador={'Totalhh'}
                                color={'#1bc943'}
                                bcolor={'rgba(27, 201, 67, 0.15)'}
                                porc={45}
                                total={dashboardData ? dashboardData.deviceCount : '-'}
                                leyenda={'Registered devices'}
                            />
                        </Paper>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <Paper className={fixedHeightPaper2}>
                            <Total
                                titulo={'Devices'}
                                indicador={'Totalhh'}
                                color={'#1bc943'}
                                bcolor={'rgba(27, 201, 67, 0.15)'}
                                porc={45}
                                total={dashboardData ? dashboardData.reports.count : '-'}
                                leyenda={'Device reports'}
                            />
                        </Paper>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <Paper className={fixedHeightPaper2}>
                            <Total titulo="3G Basestations" total={10} leyenda="Registered users" />
                        </Paper>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <Paper className={fixedHeightPaper2}>
                            <Total
                                titulo="4G Basestations"
                                total={dashboardData ? dashboardData.baseStations.count : '-'}
                                leyenda="Base Stations"
                                icon={Phone}
                            />
                        </Paper>
                    </Grid>
                </Grid>

                <Grid container spacing={3}>
                    <Grid item xs={12} sm={12} md={6}>
                        <Grid item xs={12} style={{ marginBottom: '1em' }}>
                            <Paper className={fixedHeightPaper3}>
                                <RadialBar
                                    title={'Reports by Mobile Generation'}
                                    values={dashboardData ? dashboardData.reports.countByGeneration.map(value => {
                                      return {
                                        title: value.type,
                                        total: value.count,
                                        color: "#00AAD0"
                                      }
                                    }) : []}
                                />
                            </Paper>
                        </Grid>
                        <Grid item xs={12}>
                            <Paper className={fixedHeightPaper3}>
                                <BarHorizontal
                                    title={'Base Stations by Mobile Generation'}
                                    categories= {
                                        dashboardData
                                            && dashboardData.baseStations.baseStationCountByNetworkType.map((b) => b.mobileGeneration)    
                                    }
                                    data={dashboardData && dashboardData.baseStations.baseStationCountByNetworkType.map((b) => b.count)}
                                />
                            </Paper>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6}>
                        <Paper className={fixedHeightPaper}>
                            <ProgressBar
                                titulo={'Record Count by Signal Type'}
                                data={dashboardData ? [
                                    { name: 'LTE', value: dashboardData.reports.countByGeneration.filter(r => r.type == "LTE")[0].count },
                                    { name: 'HSDPA', value: 0 },
                                    { name: 'HSPA', value: 0 },
                                    { name: 'HSPAP', value: 0 },
                                    { name: 'UMTS', value: 0 },
                                    { name: 'Unknown', value: 0 },
                                ] : [{ name: 'HSDPA', value: 0 }]}
                                max={ dashboardData ? dashboardData.reports.countByGeneration.filter(r => r.type == "LTE")[0].count : 0}
                            />
                        </Paper>
                    </Grid>
                </Grid> 
                </>}
            </Container>
        </div>
    )
}
